import { detectLanguage } from './detectLanguage';

/**
 * Switch language while preserving the current page
 * Handles language prefix addition/removal/replacement correctly
 * 
 * @param {string} currentPath - Current URL pathname (from location.pathname or router.asPath)
 * @param {string} newLang - Target language code
 * @returns {string} - New path with correct language prefix
 */
export function switchLanguage(currentPath, newLang) {
  if (!currentPath) return '/';
  
  const segments = currentPath?.split('/');
  const currentLang = detectLanguage(currentPath);
  
  let newPath;
  
  if (currentLang === 'en') {
    // English has no prefix
    if (newLang === 'en') {
      newPath = currentPath;
    } else {
      // Add language prefix
      newPath = '/' + newLang + (currentPath === '/' ? '' : currentPath);
    }
  } else {
    // Remove existing language prefix
    segments?.splice(1, 1);
    const pathWithoutLang = segments?.join('/') || '/';
    
    if (newLang === 'en') {
      // Switch to English (no prefix)
      newPath = pathWithoutLang;
    } else {
      // Replace with new language prefix
      newPath = '/' + newLang + (pathWithoutLang === '/' ? '' : pathWithoutLang);
    }
  }
  
  return newPath;
}